export const JSON_ONE1 = {
   
    "ag_id": "string",
    "me_id": "string",
    "ag_ref": "string",
    "refund_amount": 0,
    "currency": "string",
    "txn_date": "string",
    "txn_time": "string",
    "refund_ref": "string",
    "pg_ref": "string",
    "status": "string",
    "res_code": "string",
    "res_message": "string",
    "error_details": "string",
    "Is_settled": "string"

}